class JointComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { JointComponentData };
